export default __webpack_public_path__ + "static/media/Linen.e20cebb5.png";